import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import {
  Container,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './main.css'; // Ensure you import your styles

function CallToAction({ darkMode }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    serviceType: '', // New field for type of service
    specificNeeds: '', // New field for specific needs
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const theme = useTheme();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Submit handler using EmailJS
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs.send('service_azjebiv', 'template_0heukhj', formData, 'aA13HK1Kuf1g0RIO0')
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setIsSubmitting(false);
        handleClose();
        alert('Quotation request sent successfully!');
      })
      .catch((err) => {
        console.error('FAILED...', err);
        setIsSubmitting(false);
        alert('Failed to send the request. Please try again later.');
      });
  };

  return (
    <section
      id="call-to-action"
      className="call-to-action"
      style={{
        backgroundColor: darkMode ? theme.palette.background.paper : '#f9f9f9',
        color: darkMode ? '#ffffff' : '#000000',
        textAlign: 'center',
        padding: theme.spacing(4, 0),
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={9} style={{ textAlign: 'left' }}>
            <Typography variant="h4" gutterBottom>
              Ready to work with us?
            </Typography>
            <Typography variant="body1" style={{ marginBottom: theme.spacing(3) }}>
              Choosing the right accounting firm is crucial for your financial health and success.
              At Fincal Business Solutions, we combine industry expertise with a personalized approach
              to ensure your financial affairs are in safe hands.
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} style={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="warning"
              size="large"
              onClick={handleOpen}
              className="cta-btn"
            >
              Request a Quotation
            </Button>
          </Grid>
        </Grid>
      </Container>

      {/* Quotation Request Form Modal */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        aria-describedby="form-dialog-description"
      >
        <DialogTitle id="form-dialog-title">Request a Quotation</DialogTitle>
        <DialogContent>
          <DialogContentText id="form-dialog-description">
            Please fill in your details, and we will get back to you with a quotation.
          </DialogContentText>
          
          <form onSubmit={handleSubmit}>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required
            />
            <TextField
              margin="dense"
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required
            />
            {/* New Field: Type of Service */}
            <TextField
              margin="dense"
              label="Type of Service"
              name="serviceType"
              value={formData.serviceType}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required
            />
            {/* New Field: Specific Needs */}
            <TextField
              margin="dense"
              label="Specific Needs"
              name="specificNeeds"
              multiline
              rows={4}
              value={formData.specificNeeds}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required
            />
            <TextField
              margin="dense"
              label="Message"
              name="message"
              multiline
              rows={4}
              value={formData.message}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required
            />
            <DialogActions>
              <Button onClick={handleClose} color="secondary">
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </section>
  );
}

export default CallToAction;
